// 1 USD = 360 LKR (fixed rate)
const USD_RATE = 360;

export const formatCurrency = (amountInLKR, currency = 'LKR') => {
    if (amountInLKR === undefined || amountInLKR === null) {
        return currency === 'USD' ? '$0.00' : 'LKR 0.00';
    }
    const amount = Number(amountInLKR);
    if (isNaN(amount)) {
        return currency === 'USD' ? '$0.00' : 'LKR 0.00';
    }

    if (currency === 'USD') {
        const usd = (amount / USD_RATE).toFixed(2);
        return `$${usd}`;
    }

    return `LKR ${amount.toLocaleString('en-LK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
